<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.recurringEventEdit") }}</h3>
            </div>
            <div class="card-body">
                <form ref="form" class="p-4 row">
                    <div class="col-12 mt-2">
                        <label for="interval" class="form-label fw-bold">{{ $t("repeatingEvents.intervalDays") }}</label>
                        <input type="number" class="form-control" id="interval" v-model="repeatingEvent.interval_days" required>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label for="repeatFrom" class="form-label fw-bold">{{ $t("repeatingEvents.repeatFrom") }}</label>
                        <input
                            type="date"
                            class="form-control"
                            id="repeatFrom"
                            v-model="repeatingEvent.repeat_from"
                            required
                            :min="today"
                            :class="{ 'is-invalid': isInvalidFrom }"
                        >
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label for="repeatTo" class="form-label fw-bold">{{ $t("repeatingEvents.repeatTo") }}</label>
                        <input
                            type="date"
                            class="form-control"
                            id="repeatTo"
                            v-model="repeatingEvent.repeat_to"
                            required
                            :min="repeatingEvent.repeat_from || today"
                            :class="{ 'is-invalid': isInvalidDateRange }"
                        >
                    </div>
                </form>
            </div>
        </div>

         <div class="my-4">
            <button
                class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white"
                @click="submitForm"
            >
                {{ $t("utils.save") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            repeatingEvent: {},
        }
    },
    created() {
        this.getRepeatingEvent();
    },
    methods: {
        getRepeatingEvent() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/repeating-events/${this.$route.params.id}`)
            .then(res => {
                this.repeatingEvent = res.data;
            })
            .catch(error => {
                console.error("Error loading repeating event", error);
            });
        },
        validateForm() {
            if (this.$refs.form.checkValidity() === false){
                this.$refs.form.reportValidity();
                return false;
            }

            if (this.isInvalidFrom || this.isInvalidDateRange) {
                return false;
            }

            return true;
        },
        submitForm() {
            if (!this.validateForm()) return;

            const slug = this.$route.params.slug;
            const eventId = this.$route.params.id;

            const url = `${slug}/repeating-events/${eventId}/edit`
            const payload = {
                repeat_from: this.repeatingEvent.repeat_from,
                repeat_to: this.repeatingEvent.repeat_to,
                interval_days: this.repeatingEvent.interval_days,
            }

            this.$store.getters.api.patch(url, payload)
                .then(() => {
                    this.$router.push({
                        name: "RepeatingEventDetailView",
                        params: {
                            slug: slug,
                            id: eventId,
                        }
                    })
                })
                .catch(error => {
                    console.error("Error updating event.", error);
                });
        }
    },
    computed: {
        today() {
            return new Date().toISOString().slice(0, 10);
        },
        isInvalidFrom() {
            if (!this.repeatingEvent.repeat_from) return false;

            return this.repeatingEvent.repeat_from < this.today;
        },
        isInvalidDateRange() {
            if (!this.repeatingEvent.repeat_from || !this.repeatingEvent.repeat_to) return false;

            const from = new Date(this.repeatingEvent.repeat_from);
            const to = new Date(this.repeatingEvent.repeat_to);

            return to <= from;
        }
    }
}
</script>